var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Detail"},[_vm._l((_vm.detail.progresses),function(det){return [_c('my_content',{attrs:{"content":det.content,"inputStyle":det.style}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }